import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    CardBody,
    Alert,
    Button,
    Label,
    Input,
    Form,
    FormFeedback,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const UserEdit = () => {
    const params = useParams(); // Get the user ID from the URL
    const navigate = useNavigate();


    // Meta title
    document.title = "User Edit | infuseone - Admin";
    const imageUrl = `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}`;
    const [status, setStatus] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState(false);
    const [name, setName] = useState('');
    const [username, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [getdesignation, setDesignation] = useState('');
    const [getQualification, setQualification] = useState('');
    const [previewDataImage, setPreviewDataImage] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [errorimage, setErrorimage] = useState(false);

    useEffect(() => {
        fetchUserData();
    }, [params.id]);

    const fetchUserData = async () => {
        setLoading(true);
        try {
            const response = await UserService.GetUserById(params.id).json();

            if (response.status) {
                const userData = response.data;
                setName(userData.name);
                setUserName(userData.username);
                setEmail(userData.email);
                setPhoneNumber(userData.phone_number);
                setStatus(userData.is_active == 1 ? true : false);
                setPreviewDataImage(userData.profile_image ? imageUrl + '/' + userData.profile_image : null);
                setDesignation(userData.designation);
                setQualification(userData.qualification);
                setLoading(false);
            } else {
                setLoading(false);
                setError({ general: response.message });
            }
        } catch (error) {
            console.error(error);
            setError({ general: 'Something went wrong while fetching user data.' });
        }
    };

    const handleStatusChange = () => setStatus(!status);

    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (validImageTypes.includes(fileType)) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setErrorimage('Please upload a valid image.');
                return;
                // alert('Please upload a valid image file.');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            username: e.target.username.value,
            name,
            email: e.target.email.value,
            phone_number: phoneNumber,
            profile_image: previewImage ? previewImage : null,
            designation: e.target.designation.value,
            qualification: e.target.qualification.value,
            is_active: status == true ? 1 : 0,
        };
        setLoading(true);
        try {
            const response = await UserService.UpdateUser(params.id, formData).json();
            if (response.status) {
                setSuccess(response.message);
                setLoading(false);
                navigate('/user-list');
                setErrorimage('');
            } else {
                setLoading(false);
                setError(response.errors);
            }
        } catch (error) {
            console.error(error);
            setError({ general: 'Something went wrong while updating user.' });
        }
    };

    const handleNameChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setName(newValue);
        }
    };
    const handlePhoneNumberChange = (e) => {
        const newValue = e.target.value;
        if (/^\d{0,12}$/.test(newValue)) {
            setPhoneNumber(newValue);
        }
    };

    const handleDesignationChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setDesignation(newValue);
        }
    };

    const handleQualificationChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setQualification(newValue);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Edit User" />
                    {isLoading ? <Spinners setLoading={setLoading} /> :
                        <Card className="commonboxform">
                            <CardBody>
                                {success && (
                                    <Alert color="success" style={{ marginTop: "13px" }}>
                                        {success}
                                    </Alert>
                                )}
                                {error.general && (
                                    <Alert color="danger" style={{ marginTop: "13px" }}>
                                        {error.general}
                                    </Alert>
                                )}

                                {/* <h4 className="card-title mb-4">Edit User</h4> */}

                                <Form className="form-horizontal" onSubmit={handleSubmit}>

                                    <div className="mb-3">
                                        <Label className="form-label">Username <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            name="username"
                                            placeholder="Enter username"
                                            defaultValue={username}
                                        />
                                        {error.username && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.username[0]}</FormFeedback>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <Label className="form-label">Name <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i>
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            placeholder="Enter name"
                                            value={name}
                                            onChange={handleNameChange}
                                        />
                                        {error.name && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.name[0]}</FormFeedback>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <Label className="form-label">Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                        <Input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            placeholder="Enter email"
                                            defaultValue={email} // Placeholder for existing email
                                            name="email" // Note: Also ensure email is passed in response for existing users
                                        />
                                        {error.email && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.email[0]}</FormFeedback>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <Label className="form-label">Phone Number <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="phone_number"
                                            placeholder="Enter phone number"
                                            onChange={handlePhoneNumberChange}
                                            value={phoneNumber}
                                        />
                                        {error.phone_number && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.phone_number[0]}</FormFeedback>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <Label className="form-label">Designation</Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="designation"
                                            name="designation"
                                            placeholder="Enter Designation"
                                            value={getdesignation}
                                            onChange={handleDesignationChange}
                                        />
                                        {error.designation && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.designation[0]}</FormFeedback>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <Label className="form-label">Qualification</Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="qualification"
                                            name="qualification"
                                            placeholder="Enter Qualification"
                                            value={getQualification}
                                            onChange={handleQualificationChange}
                                        />
                                        {error.qualification && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.qualification[0]}</FormFeedback>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <Label className="form-label">Profile Image</Label>
                                        {(previewDataImage || previewImage) && (
                                            <div className="mb-3 text-left">
                                                <img
                                                    src={previewDataImage ? previewDataImage : previewImage}
                                                    alt="Profile Preview"
                                                    className="img-fluid"
                                                    style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                                                />
                                            </div>
                                        )}
                                        <Input
                                            type="file"
                                            className="form-control"
                                            id="profile_image"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        {error.profile_image && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.profile_image[0]}</FormFeedback>
                                        )}
                                        {errorimage && (
                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <Label className="form-label">Status</Label>
                                        <div className="form-check form-switch form-switch-lg mb-3">
                                            <Input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="customSwitchsizelg"
                                                name="status"
                                                checked={status}
                                                onClick={handleStatusChange}
                                            />
                                            <Label className="form-check-label" htmlFor="customSwitchsizelg">
                                                {status ? 'Active' : 'Inactive'}
                                            </Label>
                                        </div>
                                    </div>

                                    <div className="text-left mt-4">
                                        <Button type="submit" color="secondary">
                                            Update
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </div>
        </React.Fragment >
    );
};

export default UserEdit;